import cn from 'classnames';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

interface ITransferIconProps extends IConDefaultType {}

function TransferIcon({ color, className, size = 24, rotate, flip, style }: ITransferIconProps) {
  const fill = color || EColorMap.gray_0;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.207 11.757C8.29998 11.8499 8.37374 11.9602 8.42406 12.0816C8.47438 12.203 8.50029 12.3331 8.50029 12.4645C8.50029 12.5959 8.47438 12.726 8.42406 12.8474C8.37374 12.9688 8.29998 13.0791 8.207 13.172L6.38 15H16C16.2652 15 16.5196 15.1054 16.7071 15.2929C16.8946 15.4804 17 15.7348 17 16C17 16.2652 16.8946 16.5196 16.7071 16.7071C16.5196 16.8946 16.2652 17 16 17H6.38L8.208 18.828C8.30091 18.9208 8.37462 19.0311 8.42493 19.1524C8.47524 19.2737 8.50116 19.4038 8.5012 19.5351C8.50125 19.6665 8.47542 19.7966 8.4252 19.9179C8.37498 20.0393 8.30134 20.1496 8.2085 20.2425C8.11566 20.3354 8.00542 20.4091 7.88409 20.4594C7.76275 20.5097 7.6327 20.5357 7.50135 20.5357C7.37001 20.5357 7.23993 20.5099 7.11857 20.4597C6.9972 20.4095 6.88691 20.3358 6.794 20.243L3.258 16.707C3.07053 16.5195 2.96521 16.2652 2.96521 16C2.96521 15.7348 3.07053 15.4805 3.258 15.293L6.794 11.757C6.98153 11.5695 7.23584 11.4642 7.501 11.4642C7.76616 11.4642 8.02047 11.5695 8.208 11.757H8.207ZM15.793 3.757C15.9652 3.58482 16.1943 3.48139 16.4373 3.46611C16.6803 3.45083 16.9206 3.52475 17.113 3.674L17.207 3.757L20.743 7.293C20.9152 7.46519 21.0186 7.69429 21.0339 7.93732C21.0492 8.18035 20.9753 8.4206 20.826 8.613L20.743 8.707L17.207 12.242C17.027 12.4213 16.7856 12.5255 16.5316 12.5332C16.2777 12.541 16.0303 12.4518 15.8397 12.2838C15.6492 12.1157 15.5297 11.8814 15.5056 11.6285C15.4815 11.3756 15.5546 11.123 15.71 10.922L15.793 10.828L17.62 9H8C7.74512 8.99972 7.49997 8.90212 7.31463 8.72715C7.1293 8.55218 7.01777 8.31305 7.00283 8.05861C6.98789 7.80416 7.07067 7.55362 7.23427 7.35817C7.39786 7.16271 7.6299 7.0371 7.883 7.007L8 7H17.621L15.793 5.17C15.6055 4.98247 15.5002 4.72816 15.5002 4.463C15.5002 4.19784 15.6055 3.94453 15.793 3.757Z"
          fill={fill}
        />
      </svg>
    </i>
  );
}

export default TransferIcon;
